module.exports = __webpack_public_path__ + "img/javier-flores.21bcbebe.svg";